import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonService} from '../common.service';
import {Router, ActivatedRoute} from '@angular/router';
import {TabsetComponent} from 'ngx-bootstrap/tabs/public_api';
import {PlatformLocation} from '@angular/common';
import { Subject } from 'rxjs';
import { CommonVariablesService } from './../common-variables.service';

@Component({
  selector: 'app-declarationdeclaration',
  templateUrl: './declaration.component.html',
  styleUrls: ['./declaration.component.css']
})
export class DeclarationComponent implements OnInit, OnDestroy {
  @ViewChild('tabset', {static: false}) tabset: TabsetComponent;
  oneAtATime = true;
  ShowRightContent = false;
  headerContent: any;
  pageContent: number;
  pageSubscription: any;
  header: any;
  gcPolicyNo = '';
  policyRenewalCounter = '';
  masterPolicyId = '';
  declarationFormData: any = [];
  getUserType = '';
  expression: any = [];
  impersonateFlag: boolean = false; // added by obulakshmi
  declarationData: any = {
    headerData: [],
    contentData: []
  };
	dtTrigger: Subject<any> = new Subject();
  dtOptions: DataTables.Settings = {};
  isMasterPolicyInactived: boolean = false;
  gcEndorsementDetails = '';
  masterPolicyList: any = [];
  declarationCard: any;
  gridView: boolean = false;


  constructor(
    public commonService: CommonService,
    private commonVariablesService: CommonVariablesService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private location: PlatformLocation,
	
  ) { }

  async ngOnInit() {
	window.localStorage.setItem('pageName','');
    const ret = this.commonVariablesService.productId ? true : await this.commonService.commonLOBvalues();
    if (!ret) {
      this.router.navigate(['/login', { url: 'Declaration' }]);
    }
    const tmpUrl: any = (this.router.url).split('/');
    /* const tmpUserType = this.cookie.get('userProfile'); */
    const tmpUserType = window.localStorage.getItem('userProfile');
    this.getUserType = this.commonService.decryptData(tmpUserType);
    // this.getUserType = 'underwriter';
    if (this.getUserType == 'underwriter' || this.getUserType == 'helpdesk' || this.getUserType == 'hub' || this.getUserType == 'producerUser' || this.getUserType == 'clientUser') {
      // functionality here
    }
    this.dtOptions = {
      dom: 'ftipr',
      destroy: true,
      pageLength: 25,
      language: {
      emptyTable: 'No Records available'
      }
    };
    this.commonService.asObservable.subscribe(async user => {
      const datas = user || {id: tmpUrl[2]};
      await this.onLoadFunctionality(datas);
    });
    
    this.pageSubscription = this.activatedRoute.params.subscribe(async val => {
      if (val.id != 0 && val.id != 1) {
        await this.onLoadFunctionality(val);
      }
      // (val.id != 0 && val.id != 1) ? await this.onLoadFunctionality(val) : '';
    });
    
    this.location.onPopState(() => {
      if(tmpUrl[2] == 5) {
        this.gotoPageContent(1);
      }
    });
	
  }

  ngOnDestroy() {
    if (this.pageSubscription) {
      this.pageSubscription.unsubscribe();
    }
    // this.pageSubscription ? this.pageSubscription.unsubscribe() : '';
    sessionStorage.removeItem('declaration-header');
    window.localStorage.removeItem('declaration-header');
  }

  /*
	* Created By : Sharann N
	* Description : load value in declaration header (dark blue color header).
	*********************************************/
  loadDeclarationHeader() {
    this.headerContent = {
      policy_no: this.header.tp_policy_no,
      insured_name: this.header.insured_name,
      city: this.header.insured_city
    };
  }

  /*
	* Created By : Sharann N
	* Description : page onload functionalities.
	*********************************************/
  async onLoadFunctionality(data) {

    this.header = JSON.parse(window.localStorage.getItem('declaration-header') || '{}');
    this.pageContent = Number(data.id) || 0;
    
    if ([1, 2, 3, 4, 5, 8, 9, 10, 11].includes(this.pageContent)) {
      this.gcPolicyNo = this.header.tp_policy_no;
      this.policyRenewalCounter = this.header.actual_renewal_counter;
      this.masterPolicyId = (this.pageContent == 1 && (this.getUserType == 'underwriter' || this.getUserType == 'helpdesk')) ? '' : this.header.policy_id;
    }

    //check master policy is active or not
    /* if ([0, 1, 2, 3, 5, 8, 9, 10, 11].includes(this.pageContent) && this.header.policy_no) {
      this.isMasterPolicyInactived = (this.header.masterpolicy_status == 1) ? true : false;
    } */

    this.gridView = (this.getUserType == 'producerUser' || this.getUserType == 'clientUser') ? true : false;
    if (this.gridView && this.pageContent <= 0 && this.getUserType != 'underwriter') {
      // this.masterPolicyList = await this.commonService.formMasterPolicyList('Declaration');
    }

    if (this.pageContent == 0 && this.getUserType != 'underwriter' && this.getUserType != 'helpdesk') {
      this.header.header_policy = '';
      /* sessionStorage.setItem('declaration-header', JSON.stringify(this.header));  */
      window.localStorage.setItem('declaration-header', JSON.stringify(this.header)); 
    }
  }

  /*
	* Created By : Sharann N
	* Description : navigate to child component.
	*********************************************/
  async gotoPageContent(pageId) {
    await this.commonService.navigateToDecl(pageId);
  }
  
  /*
	* Created By : Sharann N
	* Description : emits declarationForm field values.
	*********************************************/
  loadAccordion(event) {
    this.declarationFormData = event;
  }

  /*
	* Created By : Sharann N
	* Description : to get policy details.
	*********************************************/ 
  async getPolicyData(policyNo) {
    const policyUrl = `${this.commonVariablesService.baseURL}api/v1/policy`;
    const paramData = {
      policy_no: policyNo
    };
    const response = await this.commonService.httpGetMethod(policyUrl, 'application/json', true, paramData, 'Declaration', this.impersonateFlag);
    const ret = (response.status == 0) ? (response.data[0] || {}) : {};
    if (JSON.stringify(ret) == '{}') {
      this.commonService.errorsmsg(response.txt || 'Unable to get policy details', '');
    }
    return ret;
  }
  
  /*
	* Created By : Sharann N
	* Description : goto certificate page.
	*********************************************/ 
  async gotoCertificateList(idx) {
    this.masterPolicyList = this.commonService.gcPolicyList;
    await this.commonService.setCertificateParmsToLStorage({
      value: this.masterPolicyList[idx].search_val,
      item: this.masterPolicyList[idx]
    });
    this.commonService.passValue({ id: 1 });
    this.router.navigate(['/declaration', 1]);
  }

  /*
	* Created By : Sharann N
	* Description : set css onmouse event.
	*********************************************/ 
  changeStyle(event) {
    this.declarationCard = event.type == 'mouseover' ? 'yellow' : 'red';
  }

}